/**
 * @file
 * Behaviors for the Header.
 */

!((Drupal, $) => {
  'use strict';

  Drupal.behaviors.headerNavigation = {
    attach: function(context) {
      $('.aho-navigation__button', context).on('click', function() {
        $(this).toggleClass('aho-navigation__button-active');
        $('.aho-header__navigation').slideToggle();
      });
    }
  };
})(Drupal, jQuery);
